var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-dropdown-item',{attrs:{"type":"link","loading":_vm.is.loading},nativeOn:{"click":function($event){return _vm.onClick($event)}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }